import { render, staticRenderFns } from "./AssignRoles.vue?vue&type=template&id=a868b674&scoped=true"
import script from "./AssignRoles.vue?vue&type=script&lang=js"
export * from "./AssignRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a868b674",
  null
  
)

export default component.exports